export const TEST_ID = {
  ROOT_LAYOUT: 'cb-root-layout',
  BOOKING_FLOW: 'cb-booking-layout',
  REASON_FORM: 'cb-reason-form',
  REASON_SUCCESS: 'cb-reason-success',
  BOOKING_SUCCESS: 'cb-booking-sucess',
  IDENTIFICATION_FLOW: 'cb-identification-flow',
  CANCELLATION_POLICY: 'cb-cancellation-policy',
  SEQUENTIAL_BOOKING_SUCCESS: 'cb-sequential-booking-success',
  RSVP_FLOW: 'cb-rsvp-flow',
  ERROR_PAGE: 'cb-error-page',
};
